import React from 'react'
import { PermissionGroup } from '../components/permissionGroup'
import { Permission, UserRole } from 'settings/schema'
import {
    UserRoleSection,
    ProductPermissionsSection,
    OrderPermissionsSection,
    CartPermissionsSection,
} from '../sections'
import { LucideIcon } from 'utils/lucideIcon'
import './general.scss'

interface GeneralPermissionGroupProps {
    userRole: UserRole
    isAdminGranted: boolean
    handlePermissionClick: (permission: Permission, granted: boolean) => void
    handleAdminClick: (granted: boolean) => void
}

export const GeneralPermissionGroup = ({
    userRole,
    isAdminGranted,
    handlePermissionClick,
    handleAdminClick,
}: GeneralPermissionGroupProps) => (
    <PermissionGroup className="general-permissions">
        <div className="section-title">Shared permissions</div>
        <div className="permission-info-box">
            <LucideIcon iconName="Info" size={16} />
            <span>Changing a permission may affect other permissions, hover over a permission to see its effects.</span>
        </div>
        {(userRole === 'admin' || userRole === 'user') && (
            <UserRoleSection isAdminGranted={isAdminGranted} handleAdminClick={handleAdminClick} />
        )}
        <ProductPermissionsSection
            userRole={userRole}
            isAdminGranted={isAdminGranted}
            handlePermissionClick={handlePermissionClick}
        />
        <OrderPermissionsSection
            userRole={userRole}
            isAdminGranted={isAdminGranted}
            handlePermissionClick={handlePermissionClick}
        />
        {userRole !== 'reseller' && (
            <CartPermissionsSection isAdminGranted={isAdminGranted} handlePermissionClick={handlePermissionClick} />
        )}
    </PermissionGroup>
)
